'use client';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './globals.css';
import i18n, { resolveClientLocale } from '@/i18n';
import { AppErrorFallback } from './app-error-fallback';

/**
 * Root layout error boundary. Next renders this instead of the root layout, so
 * it owns `<html>` and `<body>`, pulls in the global stylesheet itself, and
 * resolves the member's locale the way I18nProvider would have.
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // Subscribes this component to language changes so `<html lang>` follows the resolved locale.
  const { i18n: instance } = useTranslation('common');
  useEffect(() => {
    const target = resolveClientLocale();
    if (target !== i18n.language) void i18n.changeLanguage(target);
  }, []);

  return (
    <html lang={instance.language}>
      <body>
        <AppErrorFallback error={error} data-testid="global-error" />
      </body>
    </html>
  );
}
